module.exports = (parcelRequire.load("dJiaG")).then(() => parcelRequire('8t401'));